import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-stored-config',
  templateUrl: './stored-config.component.html',
  styleUrls: ['./stored-config.component.css']
})
export class StoredConfigComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<StoredConfigComponent>) { }

  ngOnInit() {
  } 

}
